import React, { ReactNode } from 'react';
import AccordionLayout from './Layout';

export interface AccordionProps {
  title: string;
  count?: number;
  defaultOpen?: boolean;
  sectionId?: string;
  pageContext?: string;
  children: ReactNode;
}

export function Accordion(props: AccordionProps) {
  return <AccordionLayout {...props} />;
}
